<template>
  <van-popup v-model:show="show" position="bottom" :style="{ height: '100%' }">
  <div class="message_container">
    <CustomHeader 
      :text="$t('message.messageContent')" 
      :is-popup-close-back-icon="true"  
      @close-popup="backNavigate" 
    />

    <div class="details_container" v-if="userStore.readMessage">
      
      <div class="title">
        <!-- 【{{ userStore.readMessage.id }}】  -->
        {{ $t(userStore.readMessage.title || '') }}
      </div>

      <div class="sub_text">
        {{ userStore.readMessage.content }}
      </div>

      <div class="image_container" v-if="userStore.readMessage.attachment">
        <img :src="userStore.readMessage.attachment" />
      </div>

    </div>
  </div>
  </van-popup>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import CustomHeader from '../components/common/customHeader.vue'
import { useUserStore } from '@/stores/user'

const show = ref(false)
const userStore = useUserStore()

const backNavigate = () => {
    show.value = false
    userStore.resetReadMessage()
}
const open = () => {
  show.value = true
}
defineExpose({
  open
})
</script>

<style scoped>
.message_container {
  background: #090F1F;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.details_container {
  padding: 70px 15px;
  color: #fff;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.sub_text {
  color: #8a93a6;
  font-size: 14px;
  margin-bottom: 15px;
  line-height: 20px;
}

.image_container {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.image_container img {
  width: 100%;
  border-radius: 12px;
  display: block;
}
</style>